/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';

/**
 * 
 * @export
 * @interface CsoPortalErrorDto
 */
export interface CsoPortalErrorDto {
    /**
     * 
     * @type {I18nInfo}
     * @memberof CsoPortalErrorDto
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {string}
     * @memberof CsoPortalErrorDto
     */
    remedy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CsoPortalErrorDto
     */
    $type?: CsoPortalErrorDtoTypeEnum;
}


/**
 * @export
 */
export const CsoPortalErrorDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCsoPortalDtoCsoPortalErrorDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.CsoPortal.Dto.CsoPortalErrorDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CsoPortalErrorDtoTypeEnum = typeof CsoPortalErrorDtoTypeEnum[keyof typeof CsoPortalErrorDtoTypeEnum];



/**
 * Check if a given object implements the CsoPortalErrorDto interface.
 */
export function instanceOfCsoPortalErrorDto(value?: unknown): value is CsoPortalErrorDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CsoPortalErrorDtoTypeEnum)[0];
}

export function CsoPortalErrorDtoFromJSON(json: any): CsoPortalErrorDto {
    return CsoPortalErrorDtoFromJSONTyped(json, false);
}

export function CsoPortalErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CsoPortalErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        'remedy': json['remedy'] == null ? undefined : json['remedy'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CsoPortalErrorDtoToJSON(value?: CsoPortalErrorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'i18n': I18nInfoToJSON(value['i18n']),
        'remedy': value['remedy'],
        '$type': value['$type'],
    });
}

